app.controller('CIF4-CTRL', ['$scope', '$rootScope', '$uibModal', '$q', 'appFactory','$window','KTPCamService', 'SELFIECamService','$http','$timeout','deviceDetector',
    function ($scope, $rootScope, $uibModal, $q, appFactory, $window, KTPCamService, SELFIECamService, $http, $timeout, deviceDetector) {

    $scope.allowedExt = ['.jpg', '.jpeg', '.bmp', '.png'];
    $scope.agree1 = false;
    $scope.agree2 = false;
    $scope.agree3 = false;
    $scope.agree4 = false;
    $scope.device = deviceDetector;

    $scope.filenameKTP = "";
    $scope.fileKTP = "";
    $scope.fileKTPext = "";
    $scope.KTPFile = [];

    $scope.filenameNPWP = "";
    $scope.fileNPWP = "";
    $scope.fileNPWPext = "";
    $scope.NPWPile = [];

    $scope.filenameFotoDiri = "";
    $scope.fileFotoDiri = "";
    $scope.fileFotoDiriext = "";
    $scope.fotodiriFile = [];

    $scope.filenameTandaTangan = "";
    $scope.fileTandaTangan = "";
    $scope.fileTandaTanganext = "";
    $scope.tandatanganFile = [];

    $scope.append = '';

    $scope.finishSignature = false;

    $scope.tnc1 = function () {

        var url = $window.open("https://eform-uat.yuanta.co.id/PDFTemplate/Persyaratan.pdf", "_blank");
        url.focus();
        $scope.disclaimerTNC1 = true;
    };

    $scope.openCamera = function (tipe) {
        let message = tipe;
        let url = 'ModalCamera.html';
        let ctrl = 'CameraController';


        //if ($scope.device.isMobile()) {
        //    //url = 'ModalBrowse.html';
        //    //ctrl = 'BrowseController';
        //    //$scope.append = 'data:image/png;base64,';
        //}

        var modalInstance = $uibModal.open({
            animation: true,
            templateUrl: url,
            controller: ctrl,
            size: 'md',
            resolve: {
                items: function () {
                    return message;
                }
            }
        });
        modalInstance.result.then(function (resolvedResponse) {
            console.log('ktp',resolvedResponse);
            if (resolvedResponse) {
                if (tipe == "KTP")
                    $scope.ktpPhoto = resolvedResponse;
                else if (tipe == "NPWP")
                    $scope.npwpPhoto = resolvedResponse;
                else if (tipe == "KTPSpouse")
                    $scope.ktpPhotoSpouse = resolvedResponse;
                else if (tipe == "NPWPSpouse")
                    $scope.npwpPhotoSpouse = resolvedResponse;
                else if (tipe == "SELFIE")
                    $scope.selfiePhoto = resolvedResponse;
                //else
                //    $scope.ttdPhoto = resolvedResponse;

                var SWALtranslate = $scope.SWALtranslate('tttembed');

                if ($scope.ttdPhoto != '') {
                    Swal.fire({
                        title: SWALtranslate.title,
                        text: SWALtranslate.message,
                        //imageUrl: 'img/logo/Unggah Foto.png',
                        imageAlt: 'Preparation',
                        imageHeight: 250,
                        animation: false
                    });
                }
            }
        }, function () { });
    };

    $scope.remove = function (tipe) {
        if (tipe == "KTP")
            $scope.ktpPhoto = '';
        else if (tipe == "SELFIE")
            $scope.selfiePhoto = '';
        if (tipe == "KTPSpouse")
            $scope.ktpPhotoSpouse = '';
        else if (tipe == "NPWPSpouse")
            $scope.npwpPhotoSpouse = '';
        else if (tipe == "NPWP")
            $scope.npwpPhoto = '';
        //else
        //    $scope.ttdPhoto = '';
    };

    $scope.selectKTP = function (files) {

        $scope.KTPFile = files;
        let allowed = true;
        var reader = new FileReader();

        reader.onload = function (e) {

            if (allowed) 
                $scope.fileKTP = btoa(e.target.result.toString());
        };

        reader.readAsBinaryString(files[0]);
        $scope.fileKTPext = files[0].name.substr(files[0].name.lastIndexOf('.'));

        if ($scope.allowedExt.indexOf($scope.fileKTPext.toLowerCase()) < 0) {

            allowed = false;
            $scope.fileKTPext = '';
            $scope.KTPFile = '';
            alert("Extensi yang dibolehkan : " + $scope.allowedExt);
        } else {

            $scope.filenameKTP = files[0].name;
        }
    };

    $scope.selectNPWP = function (files) {

        $scope.NPWPFile = files;
        let allowed = true;
        var reader = new FileReader();

        reader.onload = function (e) {

            if (allowed) 
                $scope.fileNPWP = btoa(e.target.result.toString());
        };

        reader.readAsBinaryString(files[0]);
        $scope.fileNPWPext = files[0].name.substr(files[0].name.lastIndexOf('.'));

        if ($scope.allowedExt.indexOf($scope.fileNPWPext.toLowerCase()) < 0) {

            allowed = false;
            $scope.fileNPWPext = '';
            $scope.NPWPFile = '';
            alert("Extensi yang dibolehkan : " + $scope.allowedExt);
        } else {

            $scope.filenameNPWP = files[0].name;
        }
    };

    $scope.selectFotoDiri = function (files) {

        $scope.fotodiriFile = files;
        let allowed = true;
        var reader = new FileReader();

        reader.onload = function (e) {

            if (allowed)
                $scope.fileFotoDiri = btoa(e.target.result.toString());
        };

        reader.readAsBinaryString(files[0]);
        $scope.fileFotoDiriext = files[0].name.substr(files[0].name.lastIndexOf('.'));

        if ($scope.allowedExt.indexOf($scope.fileFotoDiriext.toLowerCase()) < 0) {

            allowed = false;
            $scope.fileFotoDiriext = '';
            $scope.fotodiriFile = '';
            alert("Extensi yang dibolehkan : " + $scope.allowedExt);
        } else {

            $scope.filenameFotoDiri = files[0].name;
        }
    };

    $scope.selectTandaTangan = function (files) {
        $scope.tandatanganFile = files;
        let allowed = true;
        var reader = new FileReader();

        reader.onload = function (e) {
            if (allowed) {
                $scope.fileTandaTangan = btoa(e.target.result.toString());
            }
        };

        reader.readAsBinaryString(files[0]);
        $scope.fileTandaTanganext = files[0].name.substr(files[0].name.lastIndexOf('.'));
        if ($scope.allowedExt.indexOf($scope.fileTandaTanganext.toLowerCase()) < 0) {
            allowed = false;
            $scope.fileTandaTanganext = '';
            $scope.tandatanganFile = '';
            alert("Extensi yang dibolehkan : " + $scope.allowedExt);
        }
        else
            $scope.filenameTandaTangan = files[0].name;
    };

    $scope.clickRemoveKTP = function (file, event, key) {

        event.preventDefault();
        $scope.fileKTP = "";
        $scope.filenameKTP = "";
        $scope.fileKTPext = "x";
        $scope.KTPFile.splice(key, 1);
        $scope.KTPFile = [];
        return null;
    };

    $scope.clickRemoveNPWP = function (file, event, key) {

        event.preventDefault();
        $scope.fileNPWP = "";
        $scope.filenameNPWP = "";
        $scope.fileNPWPext = "x";
        $scope.NPWPFile.splice(key, 1);
        $scope.NPWPFile = [];
        return null;
    };

    $scope.clickRemoveFotoDiri = function (file, event, key) {

        event.preventDefault();
        $scope.fileFotoDiri = "";
        $scope.filenameFotoDiri = "";
        $scope.fileFotoDiriext = "x";
        $scope.fotodiriFile.splice(key, 1);
        $scope.fotodiriFile = [];

        return null;
    };

    $scope.clickRemoveTandaTangan = function (file, event, key) {
        event.preventDefault();
        $scope.fileTandaTangan = "";
        $scope.filenameTandaTangan = "";
        $scope.fileTandaTanganext = "x";
        $scope.tandatanganFile.splice(key, 1);
        $scope.tandatanganFile = [];
        return null;
    };


    $scope.resetSign = function () {
        $rootScope.AlertYesNo('question', 'Konfirmasi', "Hapus Data Tanda Tangan?")
       .then((result) => {
           if (result.value) {
               $scope.finishSignature = false;
               $scope.filenameTandaTangan = '';
               $scope.append = '';
               $scope.clear();
           }
       });
    };

    $scope.completeSign = function () {
        console.log('signature');
        $scope.signature = $scope.accept();
        $scope.append = '';
        if ($scope.signature.dataUrl && !$scope.signature.isEmpty) {
            $scope.finishSignature = true;
            $scope.CIFInvestor.TandaTanganFile = $scope.signature.dataUrl.substr($scope.signature.dataUrl.lastIndexOf(',') + 1);
            $scope.filenameTandaTangan = $scope.CIFInvestor.TandaTanganFile;
            $scope.append = 'data:image/png;base64,';
        }
        else
            $scope.filenameTandaTangan = '';
    };

    $scope.validateAgreement = function () {

        if ($scope.CIFInvestor.QuestionRDN == 1) {

            if (!$scope.agree1 || !$scope.agree2) {

                var SWALtranslate = $scope.SWALtranslate('aggreement1');
                $scope.disclaimerBank = false;
            }

            if (!$scope.agree1 && $scope.agree2) {

                var SWALtranslate = $scope.SWALtranslate('aggreement2');
                $scope.disclaimerBank = false;
            }

            if ($scope.agree1 && !$scope.agree2) {

                var SWALtranslate = $scope.SWALtranslate('aggreement3');
                $scope.disclaimerBank = false;
            }


            if ((($scope.agree1 && $scope.agree2 && $scope.agree3 && $scope.agree4 && $scope.agree6 && $scope.agree7) || $scope.agree5) && $scope.agree3 && $scope.agree4) {

                $scope.disclaimerBank = true;
                return
            }
            $rootScope.GlobalAlert('error', "", SWALtranslate.title)
        }
    }

    $scope.validateAgreementRDNBCA = function () {

        if ($scope.CIFInvestor.QuestionRDN == 1) {

            if (!$scope.agree1) {

                $scope.disclaimerRDNBCA = false;
                $scope.showAgreement(1);
            }
        }
    }


    $scope.validateAgreementTAPRESBCA = function () {

        if ($scope.CIFInvestor.QuestionRDN == 1) {

            if (!$scope.agree2) {

                $scope.disclaimerTAPRESBCA = false;
                $scope.showAgreement(2);
            }
        }
    }

    $scope.validateAgreementDEKLARASI = function () {
        if (!$scope.agree3) {

            $scope.disclaimerDEKLARASI = false;
            $scope.showAgreement(3);
        }
    }

    $scope.validateAgreementDECLARATION = function () {
        if (!$scope.agree4) {

            $scope.disclaimerDECLARATION = false;
            $scope.showAgreement(4);
        }
       
    }

    $scope.validateAgreementRDNCIMB = function () {

        if ($scope.CIFInvestor.QuestionRDN == 9) {

            if (!$scope.agree5) {

                $scope.disclaimerRDNCIMB = false;
                $scope.showAgreement(5);
            }
        }
    }

    $scope.validateAgreementRIPLAYBCA = function () {
        if ($scope.CIFInvestor.QuestionRDN == 1) {
            if (!$scope.agree6) {
                $scope.disclaimerRIPLAYBCA = false;
                $scope.showAgreement(6);
            }
        }
    }

    $scope.validateAgreementESTATEMENTBCA = function () {
        if ($scope.CIFInvestor.QuestionRDN == 1) {
            if (!$scope.agree7) {
                $scope.disclaimerESTATEMENTBCA = false;
                $scope.showAgreement(7);
            }
        }
    }


    $scope.modalMessage = {

        message: '',
        param: {}
    };


    $scope.showAgreement = function (number) {

        let htmlName = 'template/BCAagereement' + number + '.html';
        var modalInstance = $uibModal
        .open({
            animation: true,
            templateUrl: htmlName,
            controller: 'BCAAgreementCtrl',
            size: 'lg',
            backdrop: 'static',
            resolve: {

                agreementNumber: function () {

                    return number;
                }
            }
        });

        modalInstance.result.then(function (response, agree) {

            if (response == 'accept') {

                if (number == 1) {

                    $scope.agree1 = true;
                    $scope.disclaimerRDNBCA = true;
                }

                if (number == 2) {

                    $scope.agree2 = true;
                    $scope.disclaimerTAPRESBCA = true;
                }

                if (number == 3) {

                    $scope.agree3 = true;
                    $scope.disclaimerDEKLARASI = true;
                }

                if (number == 4) {

                    $scope.agree4 = true;
                    $scope.disclaimerDECLARATION = true;
                }

                if (number == 5) {

                    $scope.agree5 = true;
                    $scope.disclaimerRDNCIMB = true;
                }

                if (number == 6) {
                    $scope.agree6 = true;
                    $scope.disclaimerRIPLAYBCA = true;
                }

                if (number == 7) {
                    $scope.agree7 = true;
                    $scope.disclaimerESTATEMENTBCA = true;
                }

                if ((($scope.disclaimerRDNBCA == true && $scope.disclaimerTAPRESBCA == true && $scope.disclaimerRIPLAYBCA == true && $scope.disclaimerESTATEMENTBCA == true) || $scope.disclaimerRDNCIMB == true) && $scope.disclaimerDEKLARASI == true && $scope.disclaimerDECLARATION == true)
                    $scope.disclaimerBank = true;
            }
        }, function () { });
    };

  

    var allPromise = $q.all([
            $scope.retrieveSessions()
    ]);

    allPromise.then(function () {

        appFactory.getData(`/service/client.svc/getCIF`).then(function (data) {

            if (data.status == 200) {

                if (data.data.d.Email != null) {

                    var obj = data.data.d;
                    $scope.CIFInvestor = data.data.d;
                    $scope.CIFInvestor.Stage = 4;
                    $scope.filenameKTP = $scope.CIFInvestor.KTPFile;
                    $scope.filenameFotoDiri = $scope.CIFInvestor.SelfieFile;
                    $scope.filenameTandaTangan = $scope.CIFInvestor.TandaTanganFile;
                    $scope.filenameNPWP = $scope.CIFInvestor.NPWPFile;


                    if ($scope.filenameKTP) {

                        if (!$scope.filenameKTP.endsWith(".pdf")) {
                            $http({
                                method: 'GET',
                                url: 'FileKYC/' + $scope.filenameKTP,
                                responseType: 'blob',

                            }).then(function (response) {
                                if (response.data) {
                                    var reader = new FileReader();
                                    reader.readAsDataURL(response.data);
                                    reader.onloadend = function () {
                                        $scope.ktpPhoto = reader.result;
                                        $scope.showKTP = false;
                                    }

                                }
                                //$scope.KTPFile = [];
                                //$scope.KTPFile.push(response.data);
                            }, function (response) {
                                $scope.saveErrors = true;
                                $scope.errorMessages = {
                                    text: 'File tidak ketemu atau terhapus dari server!!!',
                                };
                                $timeout(function () {
                                    $scope.saveErrors = false;
                                }, 3000);
                            });
                        }
                    };
                    if ($scope.filenameNPWP) {

                        if (!$scope.filenameNPWP.endsWith(".pdf")) {
                            $http({
                                method: 'GET',
                                url: 'FileKYC/' + $scope.filenameNPWP,
                                responseType: 'blob',

                            }).then(function (response) {
                                if (response.data) {
                                    var reader2 = new FileReader();
                                    reader2.readAsDataURL(response.data);
                                    reader2.onloadend = function () {
                                        $scope.npwpPhoto = reader2.result;
                                    }

                                }
                                //$scope.NPWPFile = [];
                                //$scope.NPWPFile.push(response.data);
                            }, function (response) {
                                $scope.saveErrors = true;
                                $scope.errorMessages = {
                                    text: 'File tidak ketemu atau terhapus dari server!!!',
                                };
                                $timeout(function () {
                                    $scope.saveErrors = false;
                                }, 3000);
                            });
                        }
                    };
                    if ($scope.filenameFotoDiri) {

                        if (!$scope.filenameFotoDiri.endsWith(".pdf")) {
                            $http({
                                method: 'GET',
                                url: 'FileKYC/' + $scope.filenameFotoDiri,
                                responseType: 'blob',
                            }).then(function (response) {
                                if (response.data) {
                                    var reader2 = new FileReader();
                                    reader2.readAsDataURL(response.data);
                                    reader2.onloadend = function () {
                                        $scope.selfiePhoto = reader2.result;
                                    }

                                }
                                //$scope.fotodiriFile = [];
                                //$scope.fotodiriFile.push(response.data);
                            }, function (response) {
                                $scope.saveErrors = true;
                                $scope.errorMessages = {
                                    text: 'File tidak ketemu atau terhapus dari server!!!',
                                };
                                $timeout(function () {
                                    $scope.saveErrors = false;
                                }, 3000);
                            });
                        }
                    };
                    if ($scope.CIFInvestor.TandaTanganFile) {
                        $http({
                            method: 'GET',
                            url: 'FileKYC/' + $scope.CIFInvestor.TandaTanganFile,
                            responseType: 'blob',

                        }).then(function (response) {
                            $scope.append = '';
                            let reader = new FileReader();
                            reader.readAsDataURL(response.data);
                            reader.onloadend = function () {
                                $scope.filenameTandaTangan = reader.result;
                            }
                            //$scope.tandatanganFile = [];
                            //$scope.tandatanganFile.push(response.data);
                        }, function (response) {
                            $scope.saveErrors = true;
                            $scope.errorMessages = {
                                text: 'File tidak ketemu atau terhapus dari server!!!',
                            };
                            $timeout(function () {
                                $scope.saveErrors = false;
                            }, 3000);
                        });
                    };
                    if ($scope.filenameKTPSpouse) {

                        if (!$scope.filenameKTPSpouse.endsWith(".pdf")) {
                            $http({
                                method: 'GET',
                                url: 'FileKYC/' + $scope.filenameKTPSpouse,
                                responseType: 'blob',

                            }).then(function (response) {
                                if (response.data) {
                                    var reader = new FileReader();
                                    reader.readAsDataURL(response.data);
                                    reader.onloadend = function () {
                                        $scope.ktpPhotoSpouse = reader.result;
                                        $scope.showKTP = false;
                                    }

                                }
                            }, function (response) {
                                $scope.saveErrors = true;
                                $scope.errorMessages = {
                                    text: 'File tidak ketemu atau terhapus dari server!!!',
                                };
                                $timeout(function () {
                                    $scope.saveErrors = false;
                                }, 3000);
                            });
                        }
                    };
                    if ($scope.filenameNPWPSpouse) {

                        if (!$scope.filenameNPWPSpouse.endsWith(".pdf")) {
                            $http({
                                method: 'GET',
                                url: 'FileKYC/' + $scope.filenameNPWPSpouse,
                                responseType: 'blob',

                            }).then(function (response) {
                                if (response.data) {
                                    var reader2 = new FileReader();
                                    reader2.readAsDataURL(response.data);
                                    reader2.onloadend = function () {
                                        $scope.npwpPhotoSpouse = reader2.result;
                                    }

                                }
                            }, function (response) {
                                $scope.saveErrors = true;
                                $scope.errorMessages = {
                                    text: 'File tidak ketemu atau terhapus dari server!!!',
                                };
                                $timeout(function () {
                                    $scope.saveErrors = false;
                                }, 3000);
                            });
                        }
                    };
                   

                    if ($scope.CIFInvestor.IsFinished == 1) {

                        $scope.disclaimerBank = true;
                        $scope.disclaimerRDNBCA = true;
                        $scope.disclaimerTAPRESBCA = true;
                        $scope.disclaimerPTMKES = true;
                        $scope.disclaimerDEKLARASI = true;
                        $scope.disclaimerRDNCIMB = true;
                    }

                    console.log("lang", $scope.languageSelected)

                    if ($scope.languageSelected.lang == 'id') {
                        Swal.fire({
                            title: 'Upload Foto',
                            text: 'Ketentuan untuk ambil gambar',
                            imageUrl: 'img/logo/Unggah Foto.png',
                            imageAlt: 'E-KTP',
                            width: '400px',
                            animation: false
                        });

                    }

                    if ($scope.languageSelected.lang == 'en') {
                        Swal.fire({
                            title: 'Upload Foto',
                            text: 'Conditions for taking pictures',
                            imageUrl: 'img/logo/Upload Photo.png',
                            imageAlt: 'E-KTP',
                            width: '400px',
                            animation: false
                        });
                    }

                   
                }
            }
        });
    });

    $scope.submit = function () {
        console.log("ktp", $scope.ktpPhoto);

        if ($scope.ktpPhoto)
            $scope.CIFInvestor.KTPFile = $scope.ktpPhoto.replace("data:image/png;base64,", "");

        if ($scope.npwpPhoto)
            $scope.CIFInvestor.NPWPFile = $scope.npwpPhoto.replace("data:image/png;base64,", "");

        if ($scope.ktpPhotoSpouse)
            $scope.CIFInvestor.SpouseKTPFile = $scope.ktpPhotoSpouse.replace("data:image/png;base64,", "");

        if ($scope.npwpPhotoSpouse)
            $scope.CIFInvestor.SpouseNPWPFile = $scope.npwpPhotoSpouse.replace("data:image/png;base64,", "");

        //if ($scope.selfiePhoto)
        //    $scope.CIFInvestor.SelfieFile = $scope.selfiePhoto.replace("data:image/jpeg;base64,", "");

        //if ($scope.ttdPhoto)
        //    $scope.CIFInvestor.TandaTanganFile = $scope.ttdPhoto.replace("data:image/png;base64,", "");


        // dynamic sweet alert post to app.js
        // 1: set the url of post or get request
        // 2: set the sweet alert translation, refers to apps.js $scope.SWALtranslate() :preconfirm = confirmation dialog before post or get request
        // 3: set the postdata to $http request = GET : {} / POST { yourdata : data }
        // 4: set the method to $http request = "GET" / "POST"
        // 5: set the sweet alert translation, refers to apps.js $scope.SWALtranslate() :preconfirm = confirmation dialog before post or get request
        // 6: if success or no error returns then...
        var urlsvc = '/service/client.svc/SaveCIF'; // 1
        var postData = { cifdata: $scope.CIFInvestor } // 2
        var preconfirmtranslate = "submitCif4"; // 3
        var method = "POST" // 4
        $scope.PostGetSwal(preconfirmtranslate, urlsvc, postData, method, function (issuccess) {

            if (issuccess) { // 6
                $window.location.href = "#/cif/final";

                //var SWALtranslate = $scope.SWALtranslate('submitCif4success'); // 5

                //$rootScope.GlobalAlert('success', SWALtranslate.title, SWALtranslate.message).then(function () {

                //    $window.location.href = "#/cif/final";
                //});
            }
            else {
                $window.location.href = "#/login";
            }
        });
    }
    //    if ($scope.CIFInvestor.TandaTanganFile) {
    //        //$scope.CIFInvestor.KTPFile = $scope.fileKTP;
    //        //$scope.CIFInvestor.SelfieFile = $scope.fileFotoDiri;
    //        //$scope.CIFInvestor.TandaTanganFile = $scope.fileTandaTangan;
    //        //$scope.CIFInvestor.NPWPFile = $scope.fileNPWP

          
    //}
}]);